import { useTranslation } from 'react-i18next';

export interface ProgressIndicatorProps {
    percentage: number;
}

const ProgressIndicator = ({ percentage }: ProgressIndicatorProps) => {
    const { t } = useTranslation('common');

    return (
        <div className="inline-flex w-20 flex-col items-end justify-start gap-1 lg:w-auto">
            <div className="text-right text-xl leading-7 font-bold text-teal-600 lg:text-2xl lg:leading-8">
                {t('pageHeader.progressPercentage', { percent: Math.round(percentage) })}
            </div>
            <div className="flex h-2 flex-col items-start justify-start self-stretch rounded-[40px] bg-neutral-200 lg:w-36">
                <div
                    className="h-2 rounded-[40px] bg-teal-600 transition-all duration-300"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressIndicator;
